import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVLoader,
  SVListStats,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGetCompanyList } from '@/hooks/requests/useCompanies';
import CompaniesList from '@/components/companies/CompaniesList';
import { FILTERS } from '@/constants/filters';

export default function CompaniesListPage() {
  const navigate = useNavigate();
  const {
    companies,
    isCompaniesPending,
    totalRecordCount,
    aggregateInfo,
    isSuccess,
  } = useGetCompanyList();
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.STATUS],
    hasStaffFilter: true,
  });

  const stats = {
    'Total Bank Accounts': aggregateInfo?.totalActiveBankAccounts ?? 0,
    'Total Active Teammates': aggregateInfo?.totalActiveTeammates ?? 0,
    'Total Active Customers': aggregateInfo?.totalActiveConsumers ?? 0,
    'Total Active Businesses': aggregateInfo?.totalActiveBusinesses ?? 0,
  };

  return (
    <DefaultLayout
      header={`Companies ${totalRecordCount ? `(${totalRecordCount})` : ''}`}
      buttons={[
        <SVButton
          onClick={() => navigate(ROUTES.COMPANIES_ADD)}
          fullWidth
          key="add"
          aria-label="Add Company">
          Add
        </SVButton>,
      ]}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by Company Name"
      />
      {isCompaniesPending ? (
        <SVLoader />
      ) : (
        <>
          {companies.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              {aggregateInfo && <SVListStats stats={stats} />}
              <CompaniesList companies={companies} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
